import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Segment,
  Dimmer,
  Loader,
  Button,
  Image,
  Dropdown,
} from 'semantic-ui-react';
import Currency from 'react-currency-formatter';
import { Bar } from 'react-chartjs-2';
import { getCurrencyText } from '../../helpers/currency';
import { projectActions, uiActions, timerActions } from '../../actions/index';
import { isArchived } from '../../helpers/project';
import Strings from '../../common/Strings';
import Constant from '../../common/Constant';
import '../Common.css';
import './ProjectDetails.css';
import { Dialog } from '../views/Dialog';
import { exportProjectCsv } from '../../helpers/export';
import Events from '../../analytics/Events';
import Analytics from '../../analytics/Analytics';
import {
  dropSecondsAndMillisFromWorkLogMillis,
  getHoursFromMillis,
  getLoggedTimeFromHours,
  getLoggedTimeFromMillis,
  getWorkLogsForProjectGraph,
} from '../../helpers/workLog';
import { sortWorkLogsByDate } from '../../helpers/sort';

const moment = require('moment');

class ProjectDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      archiveModalOpen: false,
      deleteModalOpen: false,
      reactivateModalOpen: false,
      disconnectModalOpen: false,
      graphDate: Strings.COMMON.lifetime,
    };

    const { project } = this.props;
    Analytics.logEvent(Events.PROJECT_VIEW, {
      name: project.name,
      notes: project.notes,
      hourlyRate: project.hourlyRate,
      currencyCode: project.currencyCode,
    });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.project.id !== newProps.project.id) {
      this.setState({
        graphDate: Strings.COMMON.lifetime,
      });
    }
  }

  onPressArchive = () => {
    this.setState({ archiveModalOpen: true });
  };

  onPressEdit = () => {
    this.props.dispatch(uiActions.editProjectClicked(this.props.project));
  };

  onPressDelete = () => {
    this.setState({ deleteModalOpen: true });
  };

  onPressReactivate = () => {
    this.setState({ reactivateModalOpen: true });
  };

  onPressDisconnect = () => {
    this.setState({ disconnectModalOpen: true });
  };

  onExportClicked = () => {
    Analytics.logEvent(Events.EXPORT_PROJECT);
    const { project } = this.props;
    const { graphDate } = this.state;
    exportProjectCsv(project, graphDate, this.getFilteredWorkLogs());
  };

  getTimeRecorded() {
    return getLoggedTimeFromHours(this.getTotalLoggedHours());
  }

  getDaysActiveText(daysActive) {
    if (daysActive === 1) {
      return `${daysActive} ${Strings.COMMON.daysDiffOne}`;
    }
    return `${daysActive} ${Strings.COMMON.daysDiffOther}`;
  }

  getTotalLoggedHours() {
    let totalLoggedHours = 0;
    this.getFilteredWorkLogs().forEach(workLog => {
      totalLoggedHours += getHoursFromMillis(
        dropSecondsAndMillisFromWorkLogMillis(workLog.totalLoggedMillis),
      );
    });

    return totalLoggedHours;
  }

  getUpdatedProject(archivedAtValue) {
    const project = {
      id: this.props.project.id,
      ownerUid: this.props.project.ownerUid,
      createdAt: this.props.project.createdAt,
      archivedAt: archivedAtValue,
      name: this.props.project.name,
      color: this.props.project.color,
      info: this.props.project.info,
      hourlyRate: this.props.project.hourlyRate,
      currencyCode: this.props.project.currencyCode,
    };

    return project;
  }

  archiveProject = () => {
    this.setState({ archiveModalOpen: false });
    const archivedAt = moment(new Date()).format(Constant.DATE_FORMAT_SHORT);
    const project = this.getUpdatedProject(archivedAt);

    Analytics.logEvent(Events.PROJECT_ARCHIVE, {
      name: project.name,
      notes: project.notes,
      hourlyRate: project.hourlyRate,
      currencyCode: project.currencyCode,
    });

    this.props.dispatch(projectActions.updateProject(project));

    if (this.props.project.id === this.props.timer.projectId) {
      this.props.dispatch(timerActions.discardTimerLog(this.props.timer));
    }
  };

  deleteProject = () => {
    this.setState({ deleteModalOpen: false });
    this.props.dispatch(projectActions.deleteProject(this.props.project));
  };

  reactivateProject = () => {
    this.setState({ reactivateModalOpen: false });
    const project = this.getUpdatedProject('');

    Analytics.logEvent(Events.PROJECT_REACTIVATE, {
      name: project.name,
      notes: project.notes,
      hourlyRate: project.hourlyRate,
      currencyCode: project.currencyCode,
    });

    this.props.dispatch(projectActions.updateProject(project));
  };

  disconnectProject = () => {
    this.setState({ disconnectModalOpen: false });
    const project = this.getUpdatedProject('');
    project.companyId = '';
    project.companyName = '';
    project.companyProjectId = '';
    this.props.dispatch(projectActions.updateProject(project));
  };

  close = () => {
    this.props.dispatch(uiActions.projectClicked(undefined));
  };

  renderModals() {
    if (this.state.archiveModalOpen) {
      return (
        <Dialog
          image="/emoji/archive.png"
          title={Strings.PROJECT_DETAILS.archiveProjectModalTitle}
          body={Strings.PROJECT_DETAILS.archiveProjectModalBody}
          buttonStyle="common-modal-negative-button"
          buttonText={Strings.PROJECT_DETAILS.archive}
          buttonOnClick={this.archiveProject}
          onClose={() => this.setState({ archiveModalOpen: false })}
        />
      );
    } else if (this.state.deleteModalOpen) {
      return (
        <Dialog
          image="/emoji/bomb.svg"
          title={Strings.PROJECT_DETAILS.deleteProjectModalTitle}
          body={Strings.PROJECT_DETAILS.deleteProjectModalBody}
          buttonStyle="common-modal-negative-button"
          buttonText={Strings.PROJECT_DETAILS.delete}
          buttonOnClick={this.deleteProject}
          onClose={() => this.setState({ deleteModalOpen: false })}
        />
      );
    } else if (this.state.reactivateModalOpen) {
      return (
        <Dialog
          image="/emoji/battery.svg"
          title={Strings.PROJECT_DETAILS.reactivateProjectModalTitle}
          body={Strings.PROJECT_DETAILS.reactivateProjectModalBody}
          buttonStyle="common-modal-positive-button"
          buttonText={Strings.PROJECT_DETAILS.reactivate}
          buttonOnClick={this.reactivateProject}
          onClose={() => this.setState({ reactivateModalOpen: false })}
        />
      );
    } else if (this.state.disconnectModalOpen) {
      return (
        <Dialog
          image="/emoji/bomb.svg"
          title={Strings.PROJECT_DETAILS.disconnectProjectModalTitle}
          body={Strings.PROJECT_DETAILS.disconnectProjectModalBody}
          buttonStyle="common-modal-negative-button"
          buttonText={Strings.PROJECT_DETAILS.disconnect}
          buttonOnClick={this.disconnectProject}
          onClose={() => this.setState({ disconnectModalOpen: false })}
        />
      );
    }

    return null;
  }

  renderProjectCompany() {
    const { companyName } = this.props.project;
    if (companyName) {
      return (
        <div className="project-details-company-container">
          <Image
            className="project-details-company-linked-image"
            src="/icon/linked.png"
          />
          <p className="project-details-company-owner">
            {Strings.PROJECT_DETAILS.projectOwner}
          </p>
          <p className="project-details-company-name">{companyName}</p>
        </div>
      );
    }
    return null;
  }

  renderProjectNotes() {
    const { info } = this.props.project;
    if (info) {
      return (
        <div id="project-details-notes-container">
          <p id="project-details-notes" className="project-details-header">
            {Strings.PROJECT_DETAILS.projectNotes}
          </p>
          <p id="project-details-notes-value" className="project-details-value">
            {info}
          </p>
        </div>
      );
    }
    return null;
  }

  renderProjectBasicDetails() {
    const { createdAt, hourlyRate, currencyCode } = this.props.project;
    const formattedCreatedAt = moment(createdAt).format('MMM D, YYYY');
    const currency = getCurrencyText(currencyCode);
    return (
      <div id="project-details-basic-details-container">
        <div className="project-details-basic-detail-container">
          <p id="project-details-created" className="project-details-header">
            {Strings.PROJECT_DETAILS.created}
          </p>
          <p
            id="project-details-created-value"
            className="project-details-value"
          >
            {formattedCreatedAt}
          </p>
        </div>
        <div className="project-details-basic-detail-container">
          <p id="project-details-amount" className="project-details-header">
            {Strings.PROJECT_DETAILS.hourlyRate}
          </p>
          <p
            id="project-details-amount-value"
            className="project-details-value"
          >
            <Currency quantity={hourlyRate} currency={currencyCode} />
          </p>
        </div>
        <div className="project-details-basic-detail-container">
          <p id="project-details-currency" className="project-details-header">
            {Strings.PROJECT_DETAILS.currency}
          </p>
          <p
            id="project-details-currency-value"
            className="project-details-value"
          >
            {currency}
          </p>
        </div>
      </div>
    );
  }

  renderProjectArchived() {
    const { archivedAt } = this.props.project;
    if (archivedAt) {
      const formattedArchivedAt = moment(archivedAt).format('MMM D, YYYY');
      return (
        <div id="project-details-archived-at-container">
          <p
            id="project-details-archived-at"
            className="project-details-header"
          >
            {Strings.PROJECT_DETAILS.archived}
          </p>
          <p
            id="project-details-archived-at-value"
            className="project-details-value"
          >
            {formattedArchivedAt}
          </p>
        </div>
      );
    }
    return null;
  }

  renderProjectStats(daysActive) {
    return (
      <div id="project-details-basic-details-container">
        <div className="project-details-basic-detail-container">
          <p
            id="project-details-days-active"
            className="project-details-header"
          >
            {Strings.PROJECT_DETAILS.daysActive}
          </p>
          <p
            id="project-details-days-active-value"
            className="project-details-value"
          >
            {this.getDaysActiveText(daysActive)}
          </p>
        </div>
        <div className="project-details-basic-detail-container">
          <p
            id="project-details-total-hours"
            className="project-details-header"
          >
            {Strings.PROJECT_DETAILS.totalHours}
          </p>
          <p
            id="project-details-total-hours-value"
            className="project-details-value"
          >
            {this.getTimeRecorded()}
          </p>
        </div>
      </div>
    );
  }

  renderProjectStatsAndGraph() {
    const labels = [];
    const hours = [];
    const workLogs = this.getFilteredWorkLogs();
    const workLogMap = new Map();
    sortWorkLogsByDate(workLogs);
    const workLogsForGraph = getWorkLogsForProjectGraph(workLogs);
    if (workLogsForGraph.length > 0) {
      let startDate = moment(workLogsForGraph[0].date);
      let endDate = moment();
      // If user has chosen month filter, let's use that month as end date for graph
      if (
        this.state.graphDate !== Strings.COMMON.lifetime &&
        workLogs.length > 0
      ) {
        endDate = moment(workLogs[0].date).endOf('month');
      }
      workLogsForGraph.forEach(w => {
        workLogMap.set(w.date, w);
      });

      while (endDate.diff(startDate, 'days') >= 0) {
        labels.push(startDate.format('MMM D, YYYY'));

        const workLog = workLogMap.get(
          startDate.format(Constant.DATE_FORMAT_SHORT),
        );
        if (workLog) {
          hours.push(getHoursFromMillis(workLog.totalLoggedMillis));
        } else {
          hours.push(0);
        }

        startDate = startDate.add(1, 'days');
      }
    }

    const barData = {
      labels,
      datasets: [
        {
          backgroundColor: this.props.project.color,
          data: hours,
        },
      ],
    };

    return (
      <div>
        {this.renderProjectStats(workLogMap.size)}
        <div id="project-details-graph">
          <Bar
            data={barData}
            width={350}
            height={160}
            options={{
              maintainAspectRatio: false,
              legend: {
                display: false,
              },
              title: {
                display: false,
              },
              tooltips: {
                titleFontFamily: 'Arial',
                titleFontSize: 11,
                titleFontStyle: 'normal',
                titleMarginBottom: 8,
                bodyFontFamily: 'Arial',
                bodyFontSize: 11,
                bodyFontStyle: 'bold',
                displayColors: false,
                callbacks: {
                  label: tooltipItem =>
                    getLoggedTimeFromHours(tooltipItem.yLabel),
                },
              },
              scales: {
                xAxes: [
                  {
                    barThickness: 8,
                    ticks: {
                      display: false,
                    },
                    gridLines: {
                      display: false,
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      suggestedMax: 8,
                      stepSize: 1,
                      beginAtZero: true,
                      display: false,
                    },
                  },
                ],
              },
            }}
          />
        </div>
      </div>
    );
  }

  renderProjectCost() {
    const { hourlyRate, currencyCode } = this.props.project;
    const amount = (hourlyRate * this.getTotalLoggedHours()).toFixed(2);
    const projectTotalAmount = parseFloat(amount);
    return (
      <div id="project-details-cost-root">
        <div id="project-details-cost-container">
          <p id="project-details-cost-header">
            {Strings.PROJECT_DETAILS.generatedCost}
          </p>
          <p id="project-details-cost-info">
            {Strings.PROJECT_DETAILS.generatedCostInfo}
          </p>
        </div>
        <p id="project-details-cost-value">
          <Currency quantity={projectTotalAmount} currency={currencyCode} />
        </p>
      </div>
    );
  }

  renderFooterButtons() {
    const { companyName } = this.props.project;
    if (companyName) {
      return (
        <div>
          <div className="project-details-footer-button-container">
            <button
              id="project-details-delete-button"
              className="project-details-delete-button"
              onClick={this.onPressDisconnect}
            >
              {Strings.PROJECT_DETAILS.disconnect}
            </button>
            <div id="project-details-space" />
            <button
              id="project-details-edit-button"
              className="common-green-button"
              onClick={this.onPressEdit}
            >
              {Strings.PROJECT_DETAILS.edit}
            </button>
          </div>
          <p className="project-details-disconnect-info">
            {Strings.PROJECT_DETAILS.disconnectInfo}
          </p>
        </div>
      );
    }

    if (isArchived(this.props.project)) {
      return (
        <div className="project-details-footer-button-container">
          <button
            id="project-details-delete-button"
            className="project-details-delete-button"
            onClick={this.onPressDelete}
          >
            {Strings.PROJECT_DETAILS.delete}
          </button>
          <div id="project-details-space" />
          <button
            id="project-details-reactivate-button"
            className="common-green-button"
            onClick={this.onPressReactivate}
          >
            {Strings.PROJECT_DETAILS.reactivate}
          </button>
        </div>
      );
    }
    return (
      <div className="project-details-footer-button-container">
        <button
          id="project-details-archive-button"
          onClick={this.onPressArchive}
        >
          {Strings.PROJECT_DETAILS.archive}
        </button>
        <div id="project-details-space" />
        <button
          id="project-details-edit-button"
          className="common-green-button"
          onClick={this.onPressEdit}
        >
          {Strings.PROJECT_DETAILS.edit}
        </button>
      </div>
    );
  }

  getDropDownData(lifetime, project, graphDate) {
    const projectCreatedAt = moment(project.createdAt).startOf('month');
    let now = moment().startOf('month');
    const months = [lifetime, now.format(Constant.DATE_FORMAT_SHORT)];
    let monthsDiff = Math.ceil(now.diff(projectCreatedAt, 'months', true));
    while (monthsDiff > 0) {
      now = now.add(-1, 'months');
      monthsDiff--;
      months.push(now.format(Constant.DATE_FORMAT_SHORT));
    }
    const dropDownText =
      graphDate === lifetime ? lifetime : moment(graphDate).format('MMMM YYYY');

    return {
      months,
      dropDownText,
    };
  }

  getFilteredWorkLogs() {
    const allWorkLogs = this.props.projectWorkLogs.asMutable();
    if (this.state.graphDate !== Strings.COMMON.lifetime) {
      const month = moment(this.state.graphDate);
      return allWorkLogs.filter(
        w =>
          moment(w.date).month() === month.month() &&
          moment(w.date).year() === month.year(),
      );
    }
    return allWorkLogs;
  }

  render() {
    const { project, loading } = this.props;
    const { name, color } = this.props.project;
    const { graphDate } = this.state;
    const workLogs = this.getFilteredWorkLogs();

    // Populate drop down months based on project creation date
    const lifetime = Strings.COMMON.lifetime;
    const { months, dropDownText } = this.getDropDownData(
      lifetime,
      project,
      graphDate,
    );

    return (
      <div className="project-details-root">
        <div className="project-details-content-container">
          <Segment basic className="project-details-content">
            <Dimmer active={loading} inverted>
              <Loader inverted />
            </Dimmer>
            {this.renderModals()}
            <div className="project-details-title-container">
              <h1
                id="project-details-title-text"
                className="project-details-title"
              >
                {Strings.PROJECT_DETAILS.projectInfo}
              </h1>
              <Button
                id="project-details-export-button"
                onClick={this.onExportClicked}
                disabled={workLogs.length === 0}
              >
                {Strings.PROJECT_DETAILS.export}
              </Button>
            </div>
            <div className="project-details-divider" />
            <div id="project-details-name-container">
              <div
                id="project-details-color"
                style={{ backgroundColor: color }}
              />
              <h1 id="project-details-name">{name}</h1>
            </div>
            {this.renderProjectCompany()}
            {this.renderProjectNotes()}
            {this.renderProjectBasicDetails()}
            {this.renderProjectArchived()}
            <div
              id="project-details-stats-divider"
              className="project-details-divider"
            />
            <div className="project-details-stats-title-container">
              <h1 id="project-details-stats-title">
                {Strings.PROJECT_DETAILS.projectStats}
              </h1>
              <Dropdown
                text={dropDownText}
                basic
                className="project-details-drop-down"
              >
                <Dropdown.Menu>
                  {months.map(month => (
                    <Dropdown.Item
                      value={month}
                      onClick={(e, { value }) => {
                        if (this.state.graphDate !== value) {
                          this.setState({ graphDate: value });
                        }
                      }}
                      className="project-details-drop-down-item"
                    >
                      {month === lifetime
                        ? lifetime
                        : moment(month).format('MMMM YYYY')}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {this.renderProjectStatsAndGraph()}
            {this.renderProjectCost()}
            <div
              id="project-details-footer-divider"
              className="project-details-divider"
            />
            {this.renderFooterButtons()}
          </Segment>
        </div>
        <Image
          id="project-details-close-button"
          src="/icon/close.svg"
          onClick={this.close}
        />
      </div>
    );
  }
}

ProjectDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    ownerUid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    archivedAt: PropTypes.string,
    hourlyRate: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
    companyName: PropTypes.string,
  }).isRequired,
  projectWorkLogs: PropTypes.arrayOf(
    PropTypes.shape({
      workLog: PropTypes.shape({
        date: PropTypes.string.isRequired,
        totalLoggedMillis: PropTypes.number.isRequired,
      }).isRequired,
    }),
  ),
  loading: PropTypes.bool,
  timer: PropTypes.shape({
    status: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
  }),
};

ProjectDetails.defaultProps = {
  projectWorkLogs: [],
  loading: false,
  timer: {
    status: Constant.TIMER_NOT_RUNNING,
    projectId: '',
  },
};

const mapStateToProps = state => ({
  project: state.projectDetails.project,
  projectWorkLogs: state.projectDetails.workLogs,
  loading: state.uiState.isProjectUpdating,
  timer: state.user.timer,
});

export default connect(mapStateToProps)(ProjectDetails);



// WEBPACK FOOTER //
// ./src/components/projects/ProjectDetails.js